import React, { Component } from "react";
import {Modal, Button, FormGroup, FormControl, ControlLabel, Grid, Row, Col, Image, Checkbox } from "react-bootstrap";
import ReactLoading from 'react-loading';

import styles from "./style.css";


//Props:
//message - "Loading. . ." by default
//isShowing - duh

class Loading extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            message: "Loading. . .",
        };
    }

    render () {
      return (<Modal style={{marginTop: "10%"}}show={this.props.isShowing} onHide={()=>{}}>
                <Modal.Body>
                  <div style={{justifyContent: "center", textAlign: "center"}}>
                      <ReactLoading className="loadingIndicator" type="spin" color="#F45F21" height={"5%"} width={"5%"}/>
                      <div className="loadingMessage">{this.props.message ? this.props.message : this.state.message}</div>

                  </div>
                </Modal.Body>
                {
                 // <Modal.Header closeButton>
                 // <Modal.Title>Modal heading</Modal.Title>
                 // </Modal.Header>
                }
             </Modal>);
    }
}

export default Loading;
